export default __webpack_public_path__ + "static/media/storageUnit1-afterD-2048w.1e40eeb0.avif";